import {Plan} from '@rechargeapps/storefront-client';
import {VariantState} from '../types';
import {discountPercentage} from '@/selling-plan/utilities';

/**
 * Calculates the price per load for a given variant and plan.
 * If a plan is provided, it applies the discount percentage to the variant price.
 * The price per load is calculated by dividing the adjusted price by the number of loads.
 *
 * @param variant - The variant state object.
 * @param plan - The plan object (optional).
 * @returns The price per load.
 */
export function calculatePricePerLoad(
  variant: VariantState,
  plan?: Plan | null
) {
  const discount = plan ? discountPercentage(plan) : 0;
  const price = variant.price * (1 - discount);
  const numberOfLoads = variant.number_of_loads;
  return !!numberOfLoads ? price / numberOfLoads : 0;
}
